export default __webpack_public_path__ + "static/media/iseo_updated.5ec9fff6.svg";